import { Image } from '@chakra-ui/react';

export const IpadImage = () => (
  <Image src="/assets/marketplace/Itriom-Marketplace-Ipad-Pro.png" w="full" />
);
